import React, { createElement as _createElement } from 'react';
import { Layer, Source } from 'react-mapbox-gl';
import { jsx as _jsx } from "react/jsx-runtime";
const noFade = {
  'raster-fade-duration': 0
};
const LAYOUT_VISIBLE = {
  visibility: 'visible'
};
const LAYOUT_INVISIBLE = {
  visibility: 'none'
};
const PAINT_INVISIBLE = {
  ...noFade,
  'raster-opacity': 0.0
};
const EMPTY_ARRAY = Object.freeze([]);
export default function SourceLevelRenderer(opts) {
  const {
    layer,
    selected,
    baseId,
    opacity,
    index,
    before
  } = opts;
  const srcId = baseId;
  const layerId = `${srcId}-layer`;
  const sid = `${srcId}-${index}`;
  const lid = `${layerId}-${index}`;
  const {
    source,
    layers
  } = layer;
  if (source == null) {
    return EMPTY_ARRAY;
  }
  const sourceKey = source.type === 'geojson' ? 'geoJsonSource' : 'tileJsonSource';
  const rtn = [/*#__PURE__*/React.createElement(Source, {
    key: sid,
    id: sid,
    [sourceKey]: source
  })];
  if (source.type === 'raster') {
    const paint = selected ? {
      ...noFade,
      'raster-opacity': opacity
    } : PAINT_INVISIBLE;
    const layout = selected ? LAYOUT_VISIBLE : LAYOUT_INVISIBLE;
    rtn.push(/*#__PURE__*/_jsx(Layer, {
      id: lid,
      type: "raster",
      sourceId: sid,
      before: before,
      paint: paint,
      layout: layout
    }, lid));
  } else if (Array.isArray(layers)) {
    layers.forEach((layer, idx) => {
      const id = `${lid}-${idx}`;
      const {
        paint: p,
        layout: l,
        ...rest
      } = layer;
      rtn.push(/*#__PURE__*/_createElement(Layer, {
        ...rest,
        key: id,
        id: id,
        sourceId: sid,
        before: before,
        paint: p,
        layout: selected ? l || LAYOUT_VISIBLE : LAYOUT_INVISIBLE
      }));
    });
  }
  return rtn;
}